import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  isFetching: false,
  isFetched: false,
  error: null,
  articles: [],
  filters: {},
  sArticle: null,
};

export default {
  namespaced: true,

  state,
  mutations,
  actions,
  getters,
};
